var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewRelic = function SvgNewRelic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 832.8 959.8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00ac69",
    d: "m672.6 332.3 160.2-92.4v480L416.4 959.8V775.2l256.2-147.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1ce783",
    d: "M416.4 184.6 160.2 332.3 0 239.9 416.4 0l416.4 239.9-160.2 92.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d252c",
    d: "M256.2 572.3 0 424.6V239.9l416.4 240v479.9l-160.2-92.2z"
  })));
};
export default SvgNewRelic;